import { Badge } from '@/components/ui/badge'
import { Building2, User } from 'lucide-react'
import type { ReactElement } from 'react'

interface CustomerTypeBadgeProps {
  isBusiness?: boolean
  className?: string
}

export function CustomerTypeBadge({
  isBusiness = false,
  className = '',
}: CustomerTypeBadgeProps): ReactElement {
  const Icon = isBusiness ? Building2 : User

  return (
    <Badge variant={isBusiness ? 'periwinkle' : 'muted'} size="status" className={className}>
      <Icon className="size-3.5" />
      {isBusiness ? 'Business' : 'Individual'}
    </Badge>
  )
}
